import checksumPath from 'rlink-router/checksumPath';

const CONTENT_AUTHORING_LOCALE = 'en';

/*
BuildContext#contentForView, BuildContext#ensureContentMetaIndexFor, fullContentPath must agree on the specific format of contentMetaIndex.
 */
export default function fullContentPath (contentPath, contentMetaIndex, locale, useLongCaches, contentRoot, defaultLocale) {
  if (!locale) {
    throw new Error('Locale must be provided to fullContentPath!');
  }
  if (typeof contentPath !== 'string') {
    throw new Error(`contentPath for fullContentPath was not a string - got ${contentPath}`);
  }
  let {untranslated, translated} = contentMetaIndex;
  if (!untranslated || !translated) {
    throw new Error(`Inavalid contentMetaIndex shape - got: ${contentMetaIndex} (${JSON.stringify(contentMetaIndex)})`);
  }
  let transformPath = useLongCaches ? checksumPath : f => f;
  if (contentPath in untranslated) {
    return contentRoot + transformPath(contentPath, untranslated[contentPath]);
  } else if (contentPath in translated[locale]) {
    let localePathPrefix = '';
    if (locale !== CONTENT_AUTHORING_LOCALE) {
      localePathPrefix = `/localized-content/${locale}`;
    }
    return `${contentRoot}${localePathPrefix}${transformPath(contentPath, translated[locale][contentPath])}`;
  } else {
    throw new Error(`Cannot find ${contentPath} as neither untranslated content, nor translated content for requested locale ${locale}`);
  }
}




// WEBPACK FOOTER //
// ./lib/rlink-router/fullContentPath.js